import { useTranslation } from "../../i18n/hooks";

const ScoreVisual = ({ averageQualityScore }: { averageQualityScore: number }) => {
    const { t } = useTranslation();
    return   <svg className="w-32 h-32" viewBox="0 0 100 100">
    {(() => {
      const radius = 45;
      const circumference = 2 * Math.PI * radius;
      const offset =
        circumference * ((averageQualityScore ?? 0) / 100);
      const getStrokeColor = (score: number) => {
        if (score >= 80) return "#10B981"; // emerald-500
        if (score >= 50) return "#F59E0B"; // amber-500
        return "#EF4444"; // red-500
      };
  
      return (
        <>
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke="#f3f4f6"
            strokeWidth="8"
          />
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke={getStrokeColor(
              averageQualityScore ?? 0
            )}
            strokeWidth="8"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - offset}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
            className="transition-all duration-1000"
          />
          <text
            x="50"
            y="45"
            textAnchor="middle"
            dominantBaseline="middle"
            className="text-2xl font-bold"
          >
            {averageQualityScore}%
          </text>
          <text
            x="50"
            y="65"
            textAnchor="middle"
            dominantBaseline="middle"
            className="text-xs"
          >
            {t('dashboard.score')}
          </text>
        </>
      );
    })()}
  </svg>
  }
  

  export default ScoreVisual;